// src/services/aiChatService.ts
import axios from "axios";
import { getConfig } from "../config";
const { API_BASE_URL } = getConfig();

/** ---------- Utils ---------- */
function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = (reader.result as string) || "";
            const base64 = result.includes(",") ? result.split(",")[1] : result;
            resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export async function transcribeOnly(
    audioBlob: Blob,
    language: string = "de"
): Promise<string> {
    const audioBase64 = await blobToBase64(audioBlob);
    const { API_BASE_URL } = getConfig();
    const { data } = await axios.post(
        `${API_BASE_URL}/transcribeVoiceToText`,
        {
            audioBase64,
            audioMimeType: audioBlob.type || "audio/webm",
            language,
        },
        { responseType: "text" }
    );
    return typeof data === "string" ? data : (data?.text ?? data?.transcribedText ?? "");
}